import { createGameAssets } from "./game-assets.js";
import { initializeGame } from "./game-runtime.js";

const game = await initializeGame({ assets: createGameAssets("/") });
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/sw.js").catch(() => {});
  navigator.serviceWorker.ready.then(() => game.setOfflineReady());
}
